import * as ActionTypes from './action-types.constants';

export const sliderBeforeChange = (oldIndex, newIndex) => {
    return {
        type: ActionTypes.SLIDER_BEFORE_CHANGE,
        oldIndex,
        newIndex
    }
}


export const sliderAfterChange = (index) => {
    return {
        type: ActionTypes.SLIDER_AFTER_CHANGE,
        index
    }
}

export const clickEpisode = (el) => {
	return {
		type: ActionTypes.CLICK_EPISODE,
		el
	}
}

export const clickIfi = (el) => {
	return {
		type: ActionTypes.CLICK_IFI,
		el
	}
}